import React from 'react';
import { Link } from "react-router";
import Nav from './../components/Nav';

class NotFoundPage extends React.Component {
  render() {
    return (
      <div>
         <Nav/>
          <b className="drt">404</b>
          <div className="div">
            <p className="text1">Sayfa Bulunamadı</p>
            <div className="des">
              Aradığın sayfayı bulamadık!
              <Link to="/" className="des-link"> Ana Sayfa</Link>'ya dönebilirsin.
            </div><br/><br/>
            <a className="ul-header" style={{display: "none"}}>Bu hata genel olarak şunlardan kaynaklanır:
              <li className="li">- Var olmayan bir link, veya yanlış link</li>
              <li className="li">- Yetkililer tarafından kaldırılmış içerik</li>
            </a>
          </div>

          <style>{`
         
            c {
              color: #fff;
              font-size: 12px;
              margin: 0;
            }

            .drt {
              opacity: 0.2;
              color: #bbb;
              font-size: 400px;
              z-index: -10;
              position: fixed;
              top: 15%;
              left: 50%;
              margin-left: -334px;
            }

            .des {
              color: #000;
              font-size: 20px;
            }

            .des-link {
              font-size: 20px;
              color: #F57029;
              transition: .2s;
            }

            .des-link:hover {
              text-shadow: 0 0 5px #F57029;
            }

            .ul-header {
              margin: 10px 0 0 0;
              font-size: 15px;
              color: #000;
            }

            .li {
              list-style-type: none;
              text-align: center;
            }

            .div {
              width: 100%;
              max-width: 650px;
              height: 200px;
              margin: 0 auto;
              margin-top: 25%;
              text-align: center;
            }

            .text1 {
              font-size: 47px;
              margin: auto;
              color: #000;
            }

            @media (max-width: 623px) {
              .drt {
                font-size: 300px;
                margin-left: -250px;
              }

              .div {
                margin: 0 auto;
                margin-top: 30%;
              }

              .text1 {
                font-size: 37px;
              }
            }
           `}</style>

       </div>
    )
   
}
}

export default NotFoundPage;